const FIRST_TOUCH_ATTRIBUTION_KEY = 'speeddate_first_touch_attribution_v1';
const ATTRIBUTION_PARAM_NAMES = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'yclid',
  'ysclid',
  'rb_clickid',
];

const MAX_ATTRIBUTION_VALUE_LENGTH = 512;

const canUseBrowserStorage = () =>
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const safeParseJson = (value) => {
  try {
    return value ? JSON.parse(value) : {};
  } catch (error) {
    console.warn('Attribution parse skipped:', error);
    return {};
  }
};

const cleanValue = (value) => {
  if (value == null) {
    return null;
  }

  const normalized = String(value).trim().slice(0, MAX_ATTRIBUTION_VALUE_LENGTH);
  return normalized || null;
};

const readStoredAttribution = () => {
  if (!canUseBrowserStorage()) {
    return {};
  }

  return safeParseJson(window.localStorage.getItem(FIRST_TOUCH_ATTRIBUTION_KEY));
};

const writeStoredAttribution = (payload) => {
  if (!canUseBrowserStorage()) {
    return;
  }

  try {
    window.localStorage.setItem(FIRST_TOUCH_ATTRIBUTION_KEY, JSON.stringify(payload));
  } catch (error) {
    console.warn('Attribution storage skipped:', error);
  }
};

export const captureFirstTouchAttribution = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  const urlParams = new URLSearchParams(window.location.search);
  const foundParams = ATTRIBUTION_PARAM_NAMES.reduce((acc, paramName) => {
    const value = cleanValue(urlParams.get(paramName));
    if (value) {
      acc[paramName] = value;
    }
    return acc;
  }, {});

  if (Object.keys(foundParams).length === 0) {
    return readStoredAttribution();
  }

  const stored = readStoredAttribution();
  const nextAttribution = {
    captured_at: stored.captured_at || new Date().toISOString(),
    landing_path:
      stored.landing_path ||
      `${window.location.pathname}${window.location.search}${window.location.hash}`,
    ...stored,
  };

  for (const [key, value] of Object.entries(foundParams)) {
    if (!nextAttribution[key]) {
      nextAttribution[key] = value;
    }
  }

  writeStoredAttribution(nextAttribution);
  return nextAttribution;
};

export const getFirstTouchAttribution = () => {
  const attribution = readStoredAttribution();
  const cleaned = {};

  for (const key of ['captured_at', 'landing_path', ...ATTRIBUTION_PARAM_NAMES]) {
    const value = cleanValue(attribution[key]);
    if (value) {
      cleaned[key] = value;
    }
  }

  return cleaned;
};

const REGISTRATION_ATTRIBUTION_PARAM_NAMES = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'yclid',
  'ysclid',
  'rb_clickid',
];

export const buildRegistrationAttributionPayload = () => {
  const attribution = getFirstTouchAttribution();
  const payload = {};

  for (const key of REGISTRATION_ATTRIBUTION_PARAM_NAMES) {
    if (attribution[key]) {
      payload[key] = attribution[key];
    }
  }

  return Object.keys(payload).length > 0 ? payload : undefined;
};
